import { render, staticRenderFns } from "./ImagePersonByEmployee.vue?vue&type=template&id=21a78017&scoped=true&functional=true&"
import script from "./ImagePersonByEmployee.vue?vue&type=script&lang=js&"
export * from "./ImagePersonByEmployee.vue?vue&type=script&lang=js&"
import style0 from "./ImagePersonByEmployee.vue?vue&type=style&index=0&id=21a78017&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "21a78017",
  null
  
)

export default component.exports